import {RouteComponentProps, withRouter} from "react-router-dom";
import {connect, ConnectedProps} from "react-redux";
import {State} from "../../state";
import React, {Component} from "react";
import DataTable from "../../components/DataTable";
import { LightThemeTableWithPagination } from "../../components/LightThemeTableWithPagination";
import Dropdown from "../../components/Dropdown";
import {fetchComparisonStoreSummaryInfo, fetchStoreSummaryFilters, fetchStoreSummaryInfo } from "state/store-summary-report";
import MultiSelectDropdown from "components/MultiSelectDropdown";
import NoDataAvailable from "components/NoDataLightTheme";

// type PropsFromRedux = ConnectedProps<typeof connecter> & RouteComponentProps & StoreSummaryProps;

type ReduxProps = ConnectedProps<typeof connecter> & RouteComponentProps;
type StoreSummaryAllProps = ReduxProps & StoreSummaryProps;

interface StoreSummaryProps {
  selectedProjectId: number;
  selectedStores: number[];
  projectId:number;
}

const controllersStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    height: "100%",
    minHeight: "100%",
    justifyContent:"space-between",
    alignItems: "center",
};

const lineSeparatorCss: React.CSSProperties = {
  height: "1px",
  width: "100%%",
  backgroundColor: "#53598D26",
  margin: "5px auto",
};

const reportContainerCss: React.CSSProperties ={
  minHeight:"400px",  // ← was height:"400px", now minHeight so table isn't clipped
  overflow:"auto"
}

const chartContentCSS: React.CSSProperties = {
  display:"flex",
  width: "100%",
}

const controllerDropdownStyle: React.CSSProperties ={
    // flex:"0 0 300px",
    display: "flex",
    // flexDirection: "row",
    justifyContent:"space-between"
}

const loadingContainerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  justifyContent: "center",
  gap: "16px",
  minHeight: "300px",
};

const spinnerStyle: React.CSSProperties =  {
  width: "48px",
  height: "48px",
  border: "4px solid #e5e7eb",
  borderTop: "4px solid #f59e0b",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};

// class StoreSummary extends Component<PropsFromRedux, { parameter?: string; segmentation?: string; filters: string[] }> {
class StoreSummary extends Component<StoreSummaryAllProps,
  { parameter?: string; segmentation?: string; filters: string[]; page: number; pageSize: number , sortBy: string;
    sortOrder: "asc" | "desc";}
> {
    state = {
      parameter: undefined,
      segmentation: undefined,
      filters: [],
      page: 0,
      pageSize: 100,
      sortBy: "",
      sortOrder: "desc" as "asc" | "desc",
    };
  parameterOptions =[{
    label: "State",
    value: "state"
  },{
    label: "Store Number",
    value: "store_number"
  },
  ]

  segmentationOptions = [
    {
      label: "Brand",
      value: "brand"
    },
    {
      label: "Category",
      value: "category"
    },
    {
      label: "Category Growth",
      value: "category_growth"
    },
    {
      label: "Family",
      value: "family"
    },
    {
      label: "Innerpack",
      value: "inner_pack_original"
    },
    {
      label: "IRI Segment",
      value: "iri_segment"
    },
    {
      label: "IRI Segment With Singles",
      value: "iri_segment_with_singles"
    },
    {
      label: "Manufacturer",
      value: "manufacturer"
    },
    {
      label: "Package",
      value: "package"
    },
    {
      label: "Package Group",
      value: "package_group"
    },
    {
      label: "Sub Category",
      value: "subcategory"
    },
    {
      label: "WAMP",
      value: "wamp"
    },
    {
      label: "WAMP With Singles",
      value: "wamp_with_singles"
    },
  ]

async componentDidMount() {
  const { projectId, selectedStores } = this.props;

  this.setState(
    {
      parameter: this.parameterOptions[0].value,
      segmentation: this.segmentationOptions[2].value,
    },
    () => {
      this.loadProjectData(projectId, selectedStores); // this now handles comparison too
    }
  );
}

loadProjectData = (projectId: number, storeIds: number[]) => {
  const { parameter, segmentation, filters, page, pageSize, sortBy, sortOrder } = this.state;
  const { selectedProjectId } = this.props;

  if (segmentation) {
    this.props.fetchStoreSummaryFilters(projectId, segmentation);
  }

  const hasComparison = selectedProjectId && selectedProjectId !== -1
    ? String(selectedProjectId)
    : "";

  this.props.fetchStoreSummaryInfo(
    projectId,
    parameter || this.parameterOptions[0].value,
    segmentation || this.segmentationOptions[2].value,
    filters,
    storeIds,
    page,
    pageSize,
    hasComparison,
    sortBy,
    sortOrder
  );
};

  async componentDidUpdate(prevProps: StoreSummaryAllProps, prevState: any) {
  const { projectId, selectedProjectId, selectedStores } = this.props;

  const projectChanged = prevProps.projectId !== projectId;
  const selectedChanged = prevProps.selectedProjectId !== selectedProjectId;
  const storesChanged = JSON.stringify(prevProps.selectedStores) !== JSON.stringify(selectedStores);
  const parameterChanged = prevState.parameter !== this.state.parameter;
  const segmentationChanged = prevState.segmentation !== this.state.segmentation;
  const filterChanged = JSON.stringify(prevState.filters) !== JSON.stringify(this.state.filters);
  const pageChanged = prevState.page !== this.state.page;
  const pageSizeChanged = prevState.pageSize !== this.state.pageSize;
  const sortByChanged = prevState.sortBy !== this.state.sortBy;
  const sortOrderChanged = prevState.sortOrder !== this.state.sortOrder;

  const isInitialParamSet = prevState.parameter === undefined && this.state.parameter !== undefined;
  const isInitialSegSet = prevState.segmentation === undefined && this.state.segmentation !== undefined;

  if (isInitialParamSet || isInitialSegSet) return;

  if (
    projectChanged || selectedChanged || storesChanged ||
    parameterChanged || segmentationChanged || filterChanged ||
    pageChanged || pageSizeChanged || sortByChanged || sortOrderChanged
  ) {
    this.loadProjectData(projectId, selectedStores);
  }

  if (segmentationChanged && this.state.segmentation) {
    this.props.fetchStoreSummaryFilters(projectId, this.state.segmentation);
  }
}

  // loadComparisonProjectData = async (baseProjectId: number, comparisonProjectId: number) => {
  //   try {
  //     comparisonProjectId = 3408
  //     if(this.state.parameter && this.state.segmentation && this.state.filters.length>0){
  //       this.props.fetchComparisonStoreSummaryInfo(baseProjectId, comparisonProjectId,this.state.parameter,this.state.segmentation,this.state.filters)
  //     }else if(this.state.parameter && !this.state.segmentation && this.state.filters.length==0){
  //       this.props.fetchComparisonStoreSummaryInfo(baseProjectId, comparisonProjectId,this.state.parameter,"",[])
  //     }else if(!this.state.parameter && this.state.segmentation && this.state.filters.length==0){
  //       this.props.fetchComparisonStoreSummaryInfo(baseProjectId, comparisonProjectId,"",this.state.segmentation,[])
  //     }else if(!this.state.parameter && !this.state.segmentation && this.state.filters.length>0){
  //       this.props.fetchComparisonStoreSummaryInfo(baseProjectId, comparisonProjectId,"","",this.state.filters)
  //     }else{
  //       this.props.fetchComparisonStoreSummaryInfo(baseProjectId, comparisonProjectId,"","",[]);
  //     }

  //   } catch (error) {
  //     console.error("Error loading comparison data:", error);
  //   }
  // };

  loadComparisonProjectData = (baseProjectId:number, comparisonProjectId:number, storeIds: number[]) => {
    const { parameter, segmentation, filters } = this.state;
    if (!comparisonProjectId || comparisonProjectId === -1) return;
    // this.props.fetchComparisonStoreSummaryInfo(
    //   baseProjectId,
    //   comparisonProjectId,
    //   parameter || "",
    //   segmentation || "",
    //   filters || [],
    //   storeIds || []
    // );
  };

  handlePageChange = (newPage: number, newPageSize: number) => {
    this.setState({ page: newPage-1, pageSize: newPageSize });
  };

  handleSortChange = (field: string, order: "asc" | "desc") => {
    this.setState({ sortBy: field, sortOrder: order, page: 0 });
  };

  render() {
    const { selectedProjectId, selectedStores,segmentFilters,content,comparisonData, loading } = this.props;
    const { parameter, segmentation, filters, page, pageSize } = this.state;
    let filterOptions: Array<{ label: string; value: string }> = []
    let lightTableData:any = []
    let gainTableData:any=[]
    let loosingTableData:any=[]
    let totalCount: number = 0;
    if (segmentFilters?.filterSegmentation?.length > 0) {
      const rawFilters: string[] = segmentFilters.filterSegmentation.map((item: any) => {
        const filterArray =  [item];
        return filterArray.length ? String(filterArray[0]).trim() : '';
      }).filter((f: string) => f.length > 0);

      const uniqueFilters: string[] = [...new Set(rawFilters)];
      filterOptions = uniqueFilters.map((f: string) => ({
        label: f,
        value: f
      }));
    }


    if(content && content['summaryDetails'] && content['summaryDetails'].length>0){
      lightTableData = content['summaryDetails'].filter((item:any) => {
        return !(item?.total_pods === 0 && item?.cubic_share === 0);
      });
      totalCount = content['totalCount'] ?? lightTableData[0]?.total_count ?? 0;
    }

    const tableColumnsAll= [
      { header: "Cubic Share", field: "cubic_share_post" },
      { header: "Cubic Share Prior", field: "cubic_share_prior" },
      { header: "Share Change", field: "cubic_share_change" },
    ];
    const tableColumns =
    selectedProjectId !== -1
        ? tableColumnsAll
        : [tableColumnsAll[0]];
    const dynamicColumn = {
      header: this.segmentationOptions.find((opt: any) => opt.value === segmentation)?.label ?? "Segmentation Type",
      field: "segment",
    };
    const storeParameterColumn = {
      header: this.parameterOptions.find((opt: any) => opt.value === parameter)?.label ?? "Store Parameter",
      field: "state_of_origin",  // ← was hardcoded, now dynamic
    }

    // LightThemeTable data and columns
    const storeSummaryTableAllColumns = [
      storeParameterColumn,
      dynamicColumn,
      { header: "Cubic Share", field: "cubic_share", formatter: (value: number) => value ? `${Number(value).toFixed(2)}%` : '-'  },
      { header: "Cubic Share Prior", field: "cubic_share_prior", formatter: (value: number) => value ? `${Number(value).toFixed(2)}%` : '-'  },
      { header: "Share Change", field: "cubic_share_change", formatter: (value: number) => value ? `${Number(value).toFixed(2)}%` : '-'  },
      { header: "Adds", field: "adds", },
      { header: "Deletes", field: "deletes", },
      { header: "Maintains", field: "maintains", },
      { header: "Total PODs", field: "total_pods", },
      { header: "POD change", field: "pod_change", },
      { header: "Post Total PODs", field: "post_pods", },
      { header: "Prior Total PODs", field: "prior_pods" },
      { header: "Cubic Space Post", field: "cubic_space_post_in_power" },
      { header: "Cubic Space Prior", field: "cubic_space_prior_in_power" },
      { header: "Cubic Space % Change", field: "cubic_space_change",formatter: (value: number) => value ?`${value}%` : '-' },
    ];

    const storeSummaryProjectTableAllColumns = [
    storeParameterColumn,
    dynamicColumn,
    { header: "Cubic Share", field: "post_cubic_share", formatter: (value: number) => value ? `${Number(value).toFixed(2)}%` : '-' },
    { header: "Cubic Share Prior", field: "prior_cubic_share", formatter: (value: number) => value ? `${Number(value).toFixed(2)}%` : '-' },
    { header: "Share Change", field: "share_change", formatter: (value:string) =>
        value != null
          ? `${Number(value).toFixed(2)}%`
          : '-' },
    { header: "Adds", field: "adds" },
    { header: "Deletes", field: "deletes" },
    { header: "Maintains", field: "maintains" },
    // { header: "Total PODs", field: "total_pods" },
    { header: "POD change", field: "pod_change" },
    // { header: "Adds Per Store", field: "adds_per_store" },
    // { header: "Deletes Per Store", field: "deletes_per_store" },
    { header: "Cubic Space Post", field: "post_cubic", formatter: (value:string) =>
    value != null
      ? Number(value).toFixed(2)
      : ""  },
    { header: "Cubic Space Prior", field: "prior_cubic" , formatter: (value:string) =>
    value != null
      ? Number(value).toFixed(2)
      : "" },
    { header: "Cubic Space % Change", field: "cubic_space_change", formatter: (value:string) =>
    value != null
      ? `${Number(value).toFixed(2)}%`
      : ""  },
  ];

    const lightTableColumns = selectedProjectId <0
      ? [storeSummaryTableAllColumns[0], storeSummaryTableAllColumns[1], storeSummaryTableAllColumns[2], storeSummaryTableAllColumns[8]]
      : storeSummaryProjectTableAllColumns;


    const isLoadingData = loading;


    return (
      <div className="reset-recap-container">
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            .chart-styles table thead tr th {
                position: sticky !important;
                top: 0 !important;
                z-index: 1;
                background-color: #F9FAFB;
            }
            .chart-styles > div > div {
                max-height: calc(100vh - 330px) !important;
            }
            .chart-styles table tbody tr td {
                height: 45px !important;
                vertical-align: middle;
            }
          `}
        </style>
        {/* <div style={controllersStyle}> */}
            <div className="store-summary-header">
                <div style={controllersStyle}>
                    <div>
                        Store Summary Report
                        {/* <div className="reset-recap-sub-header">Description</div> */}
                    </div>

              <div className="store-filters" style={controllerDropdownStyle}>
              <div className="filter-block" style={{ marginRight: "8px" }}>
                <div className="header-controller-dropdown">
                  Select Store Parameter
                </div>
                <div>
                    <Dropdown
                        value={this.parameterOptions.find((o:any) => o.value === parameter) || null}
                        options={this.parameterOptions}
                        onChange={(selected: any) => this.setState({ parameter: selected.value, page: 0 })}
                        placeholder="Select Store Parameter"
                        isSearchable
                        controlStyles={{ minHeight: 44, borderRadius: "16px" }}
                        noShadow={true}
                        hasDefaultAll={true}
                    />
                </div>

              </div>
              <div className="filter-block" style={{ marginRight: "8px"}}>
                <div className="header-controller-dropdown">
                  Select Segmentation
                </div>
                <div>
                    <Dropdown
                    value={this.segmentationOptions.find((o:any) => o.value === segmentation) || null}
                    options={this.segmentationOptions}
                    onChange={(selected: any) => this.setState({ segmentation: selected.value, filters: [], page: 0 })}
                    placeholder="Select Segmentation"
                    isSearchable
                    controlStyles={{ minHeight: 44, borderRadius: "16px" }}
                    noShadow={true}
                    hasDefaultAll={true}
                    />
                </div>
              </div>
              <div className="filter-block" style={{ marginRight: "8px" }}>
                <div className="header-controller-dropdown">
                  Filter Segmentation
                </div>
                <div style={{ minWidth: "220px", width: "220px" }}>  {/* ← add this */}
                  <MultiSelectDropdown
                    options={filterOptions.map((o: any) => ({ id: o.value, label: o.label }))}
                    value={filters}
                    onChange={(selected) =>
                      this.setState({ filters: Array.isArray(selected) ? selected as string[] : selected ? [selected as string] : [], page: 0 })
                    }
                    multiSelect={true}
                    placeholder="Filter Segmentation"
                    hideHeader={true}
                  />
                </div>
              </div>
            </div>
                </div>

            </div>

        {/* </div> */}

        {/* <div style={lineSeparatorCss}/> */}
        <div className="reset-recap-chart-container" style={reportContainerCss}>


          <div className="charts-row" style={chartContentCSS}>
            <div className="chart-styles" style={{ flex: 1, minWidth: 0 }}>
              {/* <div className="chart-headers">
                Report of selected category growth
              </div>
              <div className="chart-sub-header">
               Description
              </div> */}

              {/* {isLoadingData ? (
                // Show spinner while API call is in progress
                <div style={loadingContainerStyle}>
                  <div style={spinnerStyle}></div>
                </div>
              ) : lightTableData.length === 0 ? (
                // Show empty state when no data
                <div style={{ ...loadingContainerStyle, color: "#9ca3af", fontSize: "14px" }}>
                  <NoDataAvailable/>
                </div>
              ) : (
                // Show table with fresh data once loading is complete */}
                <LightThemeTableWithPagination
                    // key={`${parameter}-${segmentation}-${filters.join(",")}-${page}`}  // ← forces re-render on any change
                    data={lightTableData}
                    columns={lightTableColumns}
                    pageSize={pageSize}
                    pageSizeOptions={[100, 250, 500]}
                    showPagination={true}
                    isLoading={isLoadingData}
                    totalPages={Math.ceil(totalCount / pageSize)}
                    currentPage={page+1}
                    onPageChange={this.handlePageChange}
                    onSortChange={this.handleSortChange}
                    onClickOnRow={(row) => console.log("Clicked row:", row)}
                />
               {/* )} */}
            </div>
          </div>

        </div>
      </div>
    )
  }
}

const connecter = connect(
  (state: State) => ({
    content:state.storeSummaryDetails.content,
    segmentFilters:state.storeSummaryDetails.filters,
    comparisonData:state.storeSummaryDetails.comparisonData,
    loading: state.storeSummaryDetails.loading,
  }),
  {fetchStoreSummaryFilters,fetchStoreSummaryInfo}
);
export default connecter(withRouter(StoreSummary));
